import { render, staticRenderFns } from "./EmailModel.vue?vue&type=template&id=6d9d846c&scoped=true"
import script from "./EmailModel.vue?vue&type=script&lang=js"
export * from "./EmailModel.vue?vue&type=script&lang=js"
import style0 from "./EmailModel.vue?vue&type=style&index=0&id=6d9d846c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9d846c",
  null
  
)

export default component.exports